import {createTheme} from "@mui/material";

export const videoTheme = createTheme({
  palette: {
    primary: {
      main: '#3fa097',
    },
  },
});
